import * as React from 'react';
import * as _ from 'lodash';
import { GridWrapper, HeaderWrapper } from '../styles';
import { AgGridReact, AgGridColumnProps, AgGridColumnGroupProps } from 'ag-grid-react';
import { ActionButtonRenderer } from '../common/action-button-renderer';
import SortableHeaderComponent from '../common/sortable-header';
import {
    ICellRendererParams, GridReadyEvent, IHeaderParams, CellFocusedEvent, SortChangedEvent, GridApi, ColumnApi, ValueGetterParams,
    RowClickedEvent, CellEditingStoppedEvent, CellKeyDownEvent, CellEditingStartedEvent
} from 'ag-grid-community';
import { SaturationRenderer } from './saturation-renderer';
import { SaturationSummaryRenderer } from './saturation-summary-renderer';
import { ISaturationSummary, ISaturationSummaryProductOwner } from './saturation-summary';
import { Glyphicon, OverlayTrigger, DropdownButton, MenuItem } from 'react-bootstrap';
import { ICenterSaturation, IProductOwner, IProduct, IBaseResponse, IProductCenterForList } from '@nkr/models/index';

import {
    dashFullyUtilizedOverlay,
    pwlFullyUtilizedOverlay, pwlUtilizationOverlay, donorFollowupFullyUtilizedOverlay, donorFollowupUtilizationOverlay,
    micrositesFullyUtilizedOverlay, donorShieldDirectFullyUtilizedOverlay, donorShieldDirectUtilizationOverlay,
    PopoverWrapper, homeBloodDrawCount, directStreamlinedSerologyCount, micrositeUtilizationOverlay, donorReferralCount,
    kflActiveOverlay, kflSuccessOverlay, kflLowMmTxpsOverlay,
    voucherProgramUtilizationOverlay
} from './overlays';

import { Utility } from '@nkr/services/utility';
import { ProductActionType } from '../show';
import products from '../products';

const allowedRowSelectionColumns = ['rank', 'alias', 'xpLast12Months', 'es', 'nkrl'];

type MyColumn = AgGridColumnProps | AgGridColumnGroupProps;

interface IProps {
    data: ICenterSaturation[],
    products: IProduct[],
    productOwners: Record<string, IProductOwner>,
    productCenters: IProductCenterForList[],
    gridApi: GridApi,
    gridColumnApi: ColumnApi,
    showHighlightedRowsOnly: boolean,
    onGridReady: (event: GridReadyEvent) => void,
    onDeselectAllRows: () => void,
    onShowOnlySelectedRows: () => void,
    onItemClicked: (centerId: number, productAlias: string, action: ProductActionType) => void,
    onCloseProduct: (centerId: number, productAlias: string) => void,
    onDeleteProduct: (centerId: number, productAlias: string) => void,
    onShowNotes: (centerId: number) => void,
    onSaveCategory: (centerId: number, category: string) => void,
    onSaveSaturationAnnualGoal: (centerId: number, goal: number) => void,
    onRowClicked: (centerId: number) => void,
    onProductOwnerClicked: (productId: number) => Promise<IBaseResponse>,
    onRemoveFromSelectedRows: (centerId: number) => void
}

interface IState {
    showCategoryValues: boolean,
    showNoteValues: boolean,
    columns: MyColumn[]
}

class SaturationGrid extends React.Component<IProps, IState> {
    readonly state: IState = {
        showCategoryValues: false,
        showNoteValues: false,
        columns: []
    }

    // gridApi: GridApi = null;

    currentValue: number;

    componentDidMount = () => {
        this.setColumns();
    }

    // onGridReady = (e: GridReadyEvent) => {
    //     this.gridApi = e.api;
    //     this.props.onGridReady(e);
    // }

    setColumns = () => {
        const columns: MyColumn[] = [
            {
                colId: 'actionMenu',
                headerComponentFramework: (props: IHeaderParams) =>
                    <div>
                        <Glyphicon glyph='remove' style={{ color: 'yellow', marginRight: 5 }} title='Click to clear highlighted rows...' onClick={this.handleDeselectAllRows} />
                    </div>,
                headerName: '',
                field: 'id',
                width: 75,
                cellClass: 'action-menu',
                headerClass: 'center-list-header',
                cellRendererFramework: (props: ICellRendererParams) => {
                    if (props.data.isSummary)
                        return (
                            <div style={{ textAlign: 'right', fontSize: 12, paddingRight: 10 }}>Summary <Glyphicon glyph='chevron-right' style={{ fontSize: 10 }} /><Glyphicon glyph='chevron-right' style={{ fontSize: 10 }} /></div>
                        );

                    if (props.data.isProductOwner)
                        return (
                            <div style={{ textAlign: 'right', fontSize: 12, paddingRight: 10 }}>Product Owner <Glyphicon glyph='chevron-right' style={{ fontSize: 10 }} /><Glyphicon glyph='chevron-right' style={{ fontSize: 10 }} /></div>
                        );

                    return (
                        <div style={{ width: '100%', textAlign: 'center' }}>
                            <ActionButtonRenderer {...props} />
                        </div>
                    );
                },
                pinned: 'left',
                colSpan: (params: any) => {
                    if (params.data.isSummary || params.data.isProductOwner) {
                        return 9;
                    }

                    return 1;
                }
            },

            {
                colId: 'rank',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>R#</HeaderWrapper></SortableHeaderComponent>,
                headerName: 'R#',
                width: 40,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1,
                pinned: 'left',
                pinnedRowCellRendererFramework: () => <div></div>,
                sortable: false
            },
            {
                colId: 'alias',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Alias</HeaderWrapper></SortableHeaderComponent>,
                headerName: 'Alias',
                field: 'alias',
                width: 125,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                cellRendererFramework: (props: ICellRendererParams) => {
                    let data = props.data as ICenterSaturation;

                    return (
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '10%' }}></div>
                            <div style={{ width: '80%', textAlign: 'center' }}>{props.value}</div>
                            <div style={{ width: '10%' }}>
                                {this.props.showHighlightedRowsOnly && (
                                    <Glyphicon glyph='remove' style={{ color: '#a1a1a1' }} title='Click to remove from selected rows' onClick={() => this.props.onRemoveFromSelectedRows(data.id)} />
                                )}
                            </div>
                        </div>
                    );
                },
                pinned: 'left',
                sortable: true
            },
            {
                colId: 'xpLast12Months',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Facilitated<br />TXPs L 12</HeaderWrapper></SortableHeaderComponent>,
                headerName: 'XPs Last 12 Months',
                field: 'xpLast12Months',
                width: 75,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                pinned: 'left',
                sortingOrder: ['desc', 'asc'],
                sortable: true
            },
            {
                colId: 'drcr',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>NKR Donor<br />Referral<br />Conv Rate</HeaderWrapper></SortableHeaderComponent>,
                headerName: 'Donor Referral Conversion Rate',
                field: 'donorReferralConversionRate',
                width: 75,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                cellEditorParams: { productAlias: '', onItemClicked: this.props.onItemClicked, onCloseProduct: this.props.onCloseProduct, onDeleteProduct: this.props.onDeleteProduct },
                cellRendererFramework: SaturationRenderer,
                pinned: 'left',
                sortingOrder: ['desc', 'asc'],
                sortable: true
            },
            {
                colId: 'es',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper title='Executive Sponsor'>E/S</HeaderWrapper></SortableHeaderComponent>,
                headerName: 'Exec. Sponsor',
                field: 'executiveSponsor.abbreviation',
                width: 50,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                pinned: 'left',
                cellRendererFramework: (props: ICellRendererParams) => <div title={props.data.executiveSponsor ? props.data.executiveSponsor.name : ''}>{props.value}</div>,
                sortable: true
            },
            {
                colId: 'nkrl',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper title='NKR Liaison'>L</HeaderWrapper></SortableHeaderComponent>,
                headerName: 'NKR Liaison',
                field: 'nkrLiaisonInitials',
                width: 50,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                pinned: 'left',
                cellRendererFramework: (props: ICellRendererParams) => <div title={props.data.nkrLiaisonName}>{props.value}</div>,
                sortable: true
            },

            {
                colId: 'category',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props} enableMenu={true} menuIcon='eye-close' menuIconLocation='RIGHT' onHeaderItemClick={this.handleShowCategoryValues}>
                        <HeaderWrapper>C</HeaderWrapper>
                    </SortableHeaderComponent>,
                headerName: 'Category',
                field: 'category',
                width: 45,
                cellClass: 'center-list-cell action-menu',
                headerClass: 'center-list-header',
                pinned: 'left',
                cellRendererFramework: (props: ICellRendererParams) => {
                    if (this.state.showCategoryValues)
                        return (
                            <span className='category'>
                                <DropdownButton
                                    bsSize='xs'
                                    title={props.data.category != '' ? props.data.category : ' - '}
                                    id={'cat-' + props.data.id}
                                    noCaret
                                >
                                    <MenuItem onClick={() => this.props.onSaveCategory(props.data.id, 'A')}>A</MenuItem>
                                    <MenuItem onClick={() => this.props.onSaveCategory(props.data.id, 'B')}>B</MenuItem>
                                    <MenuItem onClick={() => this.props.onSaveCategory(props.data.id, 'C')}>C</MenuItem>
                                    <MenuItem onClick={() => this.props.onSaveCategory(props.data.id, 'D')}>D</MenuItem>
                                    <MenuItem onClick={() => this.props.onSaveCategory(props.data.id, '')}>N/A</MenuItem>
                                </DropdownButton>
                            </span>
                        );

                    return <>...</>;
                },
                valueGetter: this.categoryValueGetter,
                sortable: true,
                hide: false
            },

            {
                colId: 'notes',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props} enableMenu={true} menuIcon='eye-close' menuIconLocation='RIGHT' onHeaderItemClick={this.handleShowNoteValues}>
                        <HeaderWrapper>N</HeaderWrapper>
                    </SortableHeaderComponent>,
                headerName: 'Notes',
                field: 'notes',
                width: 45,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                pinned: 'left',
                cellRendererFramework: (props: ICellRendererParams) => {
                    if (this.state.showNoteValues)
                        return (
                            <span title={props.value} onClick={() => this.props.onShowNotes(props.data.id)}>{props.value ? props.value : '...'}</span>
                        );

                    return <>...</>;
                },
                sortable: false,
                resizable: true,
                hide: false
            },

            {
                groupId: 'pe',
                headerName: 'Paired Exchange',
                headerClass: 'center-list-paired-exchange-group-header',
                children: [
                    {
                        colId: 'peMemberCenter',
                        headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Member<br />Center</HeaderWrapper></SortableHeaderComponent>,
                        headerName: 'Member Center',
                        field: 'isMemberCenter',
                        width: 85,
                        cellClass: 'center-list-paired-exchange-cell action-menu',
                        headerClass: 'center-list-paired-exchange-header',
                        cellRendererParams: {
                            productAlias: products.MemberCenter,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.isMemberCenter == -1 ? 0.5 : props.data.isMemberCenter,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'peBillable',
                        headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Billable</HeaderWrapper></SortableHeaderComponent>,
                        headerName: 'Billable',
                        field: 'billable',
                        width: 70,
                        cellClass: 'center-list-paired-exchange-cell action-menu',
                        headerClass: 'center-list-paired-exchange-header',
                        cellRendererParams: {
                            productAlias: products.Billable,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.billable == -1 ? 0.5 : props.data.billable,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'peVxm',
                        headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Screening<br />VXM User</HeaderWrapper></SortableHeaderComponent>,
                        headerName: 'Screening VXM User',
                        field: 'screeningVirtualCrossMatchUser',
                        width: 85,
                        cellClass: 'center-list-paired-exchange-cell action-menu',
                        headerClass: 'center-list-paired-exchange-header',
                        cellRendererParams: {
                            productAlias: products.Vxm,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.screeningVirtualCrossMatchUser == -1 ? 0.5 : props.data.screeningVirtualCrossMatchUser,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'peDonorProtectionAddendum',
                        headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Donor<br />Protection<br />Addendum</HeaderWrapper></SortableHeaderComponent>,
                        headerName: 'Donor Protection Addendum',
                        field: 'donorProtectionAddendumSigned',
                        width: 100,
                        cellClass: 'center-list-paired-exchange-cell action-menu',
                        headerClass: 'center-list-paired-exchange-header',
                        cellRendererParams: {
                            productAlias: products.DonorProtectionAddendumSigned,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.donorProtectionAddendumSigned == -1 ? 0.5 : props.data.donorProtectionAddendumSigned,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                ]
            },

            {
                groupId: 'kfl',
                headerName: 'Kidney For Life',
                headerClass: 'center-list-kfl-group-header',
                children: [
                    {
                        colId: 'kflA',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={kflActiveOverlay} rootClose>
                                    <HeaderWrapper>KFL<br />Active</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'KFL Active',
                        field: 'kidneyForLifeActive',
                        width: 85,
                        cellClass: 'center-list-kfl-cell action-menu',
                        headerClass: 'center-list-kfl-header',
                        cellRendererParams: {
                            productAlias: products.KidneyForLifeActive,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.kidneyForLifeActive == -1 ? 0.5 : props.data.kidneyForLifeActive,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'kflS',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={kflSuccessOverlay} rootClose>
                                    <HeaderWrapper>KFL<br />Success</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'KFL Success',
                        field: 'kidneyForLifeSuccess',
                        width: 80,
                        cellClass: 'center-list-kfl-cell',
                        headerClass: 'center-list-kfl-header',
                        cellRendererParams: {
                            productAlias: '',
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },

                    {
                        colId: 'kflLMMT',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={kflLowMmTxpsOverlay} rootClose>
                                    <HeaderWrapper>Low MM<br />TXPs</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'Low MM TXPs',
                        field: 'lowExpletTxpCountL12M',
                        width: 80,
                        cellClass: 'center-list-kfl-cell',
                        headerClass: 'center-list-kfl-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.value > 0 ? props.value : '';
                        },
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'kflEs',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Expert<br />System<br />Active</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Is Expert System',
                        field: 'isExpertSystem',
                        width: 95,
                        cellClass: 'center-list-kfl-cell action-menu',
                        headerClass: 'center-list-kfl-header',
                        cellRendererParams: {
                            productAlias: products.ExpertSystem,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.isExpertSystem == -1 ? 0.5 : props.data.isExpertSystem,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'kflESfU',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Expert<br />System<br />Fully Utilized</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Expert System Fully Utilized',
                        field: 'expertSystemFullyUtilized',
                        width: 95,
                        cellClass: 'center-list-kfl-cell action-menu',
                        headerClass: 'center-list-kfl-header',
                        cellRendererParams: {
                            productAlias: products.ExpertSystem,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.expertSystemFullyUtilized == -1 ? 0.5 : props.data.expertSystemFullyUtilized,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                ]
            },

            {
                groupId: 'pc',
                headerName: 'Partner Centers',
                headerClass: 'center-list-partner-center-group-header',
                children: [
                    {
                        colId: 'pcPartnerCenter',
                        headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Partner<br />Center</HeaderWrapper></SortableHeaderComponent>,
                        headerName: 'Partner Center',
                        field: 'partnerCenter',
                        width: 85,
                        cellClass: 'center-list-partner-center-cell action-menu',
                        headerClass: 'center-list-partner-center-header',
                        cellRendererParams: {
                            productAlias: products.PartnerCenter,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.partnerCenter == -1 ? 0.5 : props.data.partnerCenter,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'pcAllInAddendumSigned',
                        headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Equal<br />Access</HeaderWrapper></SortableHeaderComponent>,
                        headerName: 'Equal Access',
                        field: 'allInAddendumSigned',
                        width: 85,
                        cellClass: 'center-list-partner-center-cell action-menu',
                        headerClass: 'center-list-partner-center-header',
                        cellRendererParams: {
                            productAlias: products.AllInAddendumSigned,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.allInAddendumSigned == -1 ? 0.5 : props.data.allInAddendumSigned,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                ]
            },

            {
                groupId: 'ad',
                headerName: 'Voucher Donation',
                headerClass: 'center-list-advanced-donation-group-header',
                children: [
                    {
                        colId: 'adVP',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Voucher<br />Program<br />Active</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Voucher Program Active',
                        field: 'voucherProgramActive',
                        width: 85,
                        cellClass: 'center-list-advanced-donation-cell action-menu',
                        headerClass: 'center-list-advanced-donation-header',
                        cellRendererParams: {
                            productAlias: products.VoucherProgramActive,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.voucherProgramActive == -1 ? 0.5 : props.data.voucherProgramActive,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'adVPUt',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={voucherProgramUtilizationOverlay} rootClose>
                                    <HeaderWrapper>Voucher<br />Program<br />Utilization</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'Voucher Program Utilization',
                        field: 'voucherProgramUtilization',
                        width: 95,
                        cellClass: 'center-list-advanced-donation-cell',
                        headerClass: 'center-list-advanced-donation-header',
                        cellRendererParams: {
                            productAlias: products.VoucherProgramActive,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.voucherProgramActive ? props.data.voucherProgramUtilization : -1,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    }
                ]
            },

            {
                groupId: 'aw',
                headerName: 'Automated Workflow',
                headerClass: 'center-list-automated-workflow-group-header',
                children: [
                    {
                        colId: 'awDash',
                        headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Kidney<br />DASH<br />Active</HeaderWrapper></SortableHeaderComponent>,
                        headerName: 'Kidney DASH Active',
                        field: 'dashActive',
                        width: 85,
                        cellClass: 'center-list-automated-workflow-cell action-menu',
                        headerClass: 'center-list-automated-workflow-header',
                        cellRendererParams: {
                            productAlias: products.DashActive,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.dashActive == -1 ? 0.5 : props.data.dashActive,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'awDashfU',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={dashFullyUtilizedOverlay} rootClose>
                                    <HeaderWrapper>DASH Intake<br />Fully Utilized</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'DASH Intake Fully Utilized',
                        field: 'dashFullyUtilized',
                        width: 95,
                        cellClass: 'center-list-automated-workflow-cell action-menu',
                        headerClass: 'center-list-automated-workflow-header',
                        cellRendererParams: {
                            productAlias: products.DashFullyUtilized,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.dashFullyUtilized == -1 ? 0.5 : props.data.dashFullyUtilized,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'awPwl',
                        headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>
                            <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={(
                                <PopoverWrapper>
                                    <div>5% of PL DASH contacts that order labs</div>
                                </PopoverWrapper>
                            )} rootClose>
                                <HeaderWrapper>PWL<br />Active</HeaderWrapper>
                            </OverlayTrigger>
                        </SortableHeaderComponent>,
                        headerName: 'PWL Active',
                        field: 'pwlActive',
                        width: 75,
                        cellClass: 'center-list-automated-workflow-cell action-menu',
                        headerClass: 'center-list-automated-workflow-header',
                        cellRendererParams: {
                            productAlias: products.PwlActive,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.pwlActive == -1 ? 0.5 : props.data.pwlActive,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'awPwlfU',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={pwlFullyUtilizedOverlay} rootClose>
                                    <HeaderWrapper>PWL<br />Fully<br />Utilized</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'PWL Fully Utilized',
                        field: 'pwlFullyUtilized',
                        width: 75,
                        cellClass: 'center-list-automated-workflow-cell action-menu',
                        headerClass: 'center-list-automated-workflow-header',
                        cellRendererParams: {
                            productAlias: products.PwlFullyUtilized,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.pwlFullyUtilized == -1 ? 0.5 : props.data.pwlFullyUtilized,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'awPwlUt',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={pwlUtilizationOverlay} rootClose>
                                    <HeaderWrapper>PWL<br />Utilization</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'PWL Utilization',
                        field: 'pwlUtilization',
                        width: 75,
                        cellClass: 'center-list-automated-workflow-cell',
                        headerClass: 'center-list-automated-workflow-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.data.pwlActive ? parseFloat(props.value).toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%' : '-'
                        },
                        valueGetter: (props: ValueGetterParams) => props.data.pwlActive ? props.data.pwlUtilization : -1,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'awFUP',
                        headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Donor<br />Follow-Up</HeaderWrapper></SortableHeaderComponent>,
                        headerName: 'Donor Follow-Up',
                        field: 'automatedDonorFollowUpActive',
                        width: 80,
                        cellClass: 'center-list-automated-workflow-cell action-menu',
                        headerClass: 'center-list-automated-workflow-header',
                        cellRendererParams: {
                            productAlias: products.AutomatedDonorFollowUpActive,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.automatedDonorFollowUpActive == -1 ? 0.5 : props.data.automatedDonorFollowUpActive,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'awFUPfU',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={donorFollowupFullyUtilizedOverlay} rootClose>
                                    <HeaderWrapper>Donor<br />Follow-Up<br />Fully Utilized</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'Donor Follow-Up Fully Utilized',
                        field: 'automatedDonorFollowUpFullyUtilized',
                        width: 90,
                        cellClass: 'center-list-automated-workflow-cell action-menu',
                        headerClass: 'center-list-automated-workflow-header',
                        cellRendererParams: {
                            productAlias: products.AutomatedDonorFollowUpFullyUtilized,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.automatedDonorFollowUpFullyUtilized == -1 ? 0.5 : props.data.automatedDonorFollowUpFullyUtilized,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'awFUPUt',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={donorFollowupUtilizationOverlay} rootClose>
                                    <HeaderWrapper>Donor<br />Follow-Up<br />Utilization</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'Donor Follow-Up Utilization',
                        field: 'automatedDonorFollowUpUtilization',
                        width: 90,
                        cellClass: 'center-list-automated-workflow-cell',
                        headerClass: 'center-list-automated-workflow-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.data.automatedDonorFollowUpActive ? parseFloat(props.value).toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%' : '-'
                        },
                        valueGetter: (props: ValueGetterParams) => props.data.automatedDonorFollowUpActive ? props.data.automatedDonorFollowUpUtilization : -1,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },

                    {
                        colId: 'awCHBD',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={homeBloodDrawCount} rootClose>
                                    <HeaderWrapper>Custom<br />Home Blood<br />Draws</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'Custom Home Blood Draws',
                        field: 'homeBloodDrawCount',
                        width: 90,
                        cellClass: 'center-list-automated-workflow-cell action-menu',
                        headerClass: 'center-list-automated-workflow-header',
                        cellRendererParams: {
                            productAlias: products.HomeBloodDrawCountTarget,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },

                    {
                        colId: 'awLiverDash',
                        headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Liver<br />DASH<br />Active</HeaderWrapper></SortableHeaderComponent>,
                        headerName: 'Liver DASH Active',
                        field: 'liverDashActive',
                        width: 80,
                        cellClass: 'center-list-automated-workflow-cell action-menu',
                        headerClass: 'center-list-automated-workflow-header',
                        cellRendererParams: {
                            productAlias: products.LiverDashActive,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.liverDashActive == -1 ? 0.5 : props.data.liverDashActive,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    }
                ]
            },

            {
                groupId: 'serologies',
                headerName: 'Serologies',
                headerClass: 'center-list-serologies-group-header',
                children: [
                    {
                        colId: 'seroDDS',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={directStreamlinedSerologyCount} rootClose>
                                    <HeaderWrapper>Direct<br />Donor</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'Direct Donor',
                        field: 'directStreamlinedSerologyCount',
                        width: 100,
                        cellClass: 'center-list-serologies-cell action-menu',
                        headerClass: 'center-list-serologies-header',
                        cellRendererParams: {
                            productAlias: products.DirectStreamlinedSerologyCount,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.directStreamlinedSerologyCount == -1 ? 0.5 : props.data.directStreamlinedSerologyCount,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                ]
            },

            {
                groupId: 'ds',
                headerName: 'Donor Search',
                headerClass: 'center-list-donor-search-group-header',
                children: [
                    {
                        colId: 'dsMS',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Microsite<br />Centers<br />Active</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Microsite Centers Active',
                        field: 'micrositesActive',
                        width: 75,
                        cellClass: 'center-list-donor-search-cell action-menu',
                        headerClass: 'center-list-donor-search-header',
                        cellRendererParams: {
                            productAlias: products.MicrositesActive,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.micrositesActive == -1 ? 0.5 : props.data.micrositesActive,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'dsMSfU',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={micrositesFullyUtilizedOverlay} rootClose>
                                    <HeaderWrapper>Microsites<br />Fully<br />Utilized</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'Microsites Fully Utilized',
                        field: 'micrositesFullyUtilized',
                        width: 90,
                        cellClass: 'center-list-donor-search-cell action-menu',
                        headerClass: 'center-list-donor-search-header',
                        cellRendererParams: {
                            productAlias: products.MicrositesFullyUtilized,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.micrositesFullyUtilized == -1 ? 0.5 : props.data.micrositesFullyUtilized,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'dsMSUt',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={micrositeUtilizationOverlay} rootClose>
                                    <HeaderWrapper>Microsite<br />Center<br />Success</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'Microsite Center Success',
                        field: 'micrositeUtilization',
                        width: 75,
                        cellClass: 'center-list-donor-search-cell',
                        headerClass: 'center-list-donor-search-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.data.micrositesActive ? parseFloat(props.value).toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%' : '-'
                        },
                        valueGetter: (props: ValueGetterParams) => props.data.micrositesActive ? props.data.micrositeUtilization : -1,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'dsMSSC',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper> Microsites<br />Active <br /> Starter</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Microsites Active Starter Sites',
                        field: 'micrositeActiveStarterSiteCount',
                        width: 75,
                        cellClass: 'center-list-donor-search-cell',
                        headerClass: 'center-list-donor-search-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.value > 0 ? props.value : ''
                        },
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'dsMSCC',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Microsites<br />Active <br /> Custom</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Microsites Active Custom Sites',
                        field: 'micrositeActiveCustomSiteCount',
                        width: 75,
                        cellClass: 'center-list-donor-search-cell',
                        headerClass: 'center-list-donor-search-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.value > 0 ? props.value : ''
                        },
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'dsMSCC',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Microsites<br />Active <br />Total</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Microsites Active Total Sites',
                        field: 'micrositeCount',
                        width: 75,
                        cellClass: 'center-list-donor-search-cell',
                        headerClass: 'center-list-donor-search-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.value > 0 ? props.value : ''
                        },
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'dsMSSC',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper> Microsites<br />LD TXP's<br />L 12</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Microsites Living Donor TXPs L 12',
                        field: 'micrositesLdtxpL12',
                        width: 75,
                        cellClass: 'center-list-donor-search-cell',
                        headerClass: 'center-list-donor-search-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.value > 0 ? props.value : ''
                        },
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    }
                ]
            },

            {
                groupId: 'referrals',
                headerName: 'Donor Referrals',
                headerClass: 'center-list-referrals-group-header',
                children: [
                    {
                        colId: 'refD',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Active<br />Referral<br />Center</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Donor',
                        field: 'acceptingDonorReferrals',
                        width: 90,
                        cellClass: 'center-list-referrals-cell action-menu',
                        headerClass: 'center-list-referrals-header',
                        cellRendererParams: {
                            productAlias: products.AcceptingDonorReferrals,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.acceptingDonorReferrals == -1 ? 0.5 : props.data.acceptingDonorReferrals,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },

                    {
                        colId: 'refDC',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={donorReferralCount} rootClose>
                                    <HeaderWrapper>Donors<br />L 12</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'Donor Referral Count',
                        field: 'donorReferralCount',
                        width: 80,
                        cellClass: 'center-list-referrals-cell',
                        headerClass: 'center-list-referrals-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.data.automatedDonorFollowUpActive ? parseFloat(props.value).toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%' : '-'
                        },
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'refODC',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Offer<br />Donor<br />Connect</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Offer Donor Mentor',
                        field: 'offerDonorConnect',
                        width: 75,
                        cellClass: 'center-list-referrals-cell action-menu',
                        headerClass: 'center-list-referrals-header',
                        cellRendererParams: {
                            productAlias: products.OfferDonorConnect,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.offerDonorConnect == -1 ? 0.5 : props.data.offerDonorConnect,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'refDCN',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>DCN<br />Center</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'DCN Center',
                        field: 'donorCareNetworkCenter',
                        width: 75,
                        cellClass: 'center-list-referrals-cell action-menu',
                        headerClass: 'center-list-referrals-header',
                        cellRendererParams: {
                            productAlias: products.DonorCareNetworkCenter,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.donorCareNetworkCenter == -1 ? 0.5 : props.data.donorCareNetworkCenter,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    }
                ]
            },

            {
                groupId: 'referrals',
                headerName: 'Recipient Referrals',
                headerClass: 'center-list-referrals-group-header',
                children: [
                    {
                        colId: 'refP',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Accepts<br />Patients<br />w/ LDs</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Patients w/ LDs',
                        field: 'acceptingPatientReferrals',
                        width: 80,
                        cellClass: 'center-list-referrals-cell action-menu',
                        headerClass: 'center-list-referrals-header',
                        cellRendererParams: {
                            productAlias: products.AcceptingPatientReferrals,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.acceptingPatientReferrals == -1 ? 0.5 : props.data.acceptingPatientReferrals,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },

                    {
                        colId: 'refPldC',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Patients<br />w/ LDs<br /> L 12</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Patients w/ LDs Referral Count',
                        field: 'patientsWithLivingDonorReferralCount',
                        width: 85,
                        cellClass: 'center-list-referrals-cell',
                        headerClass: 'center-list-referrals-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.value > 0 ? props.value : ''
                        },
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },

                    {
                        colId: 'refMS',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Accepts<br />Microsite<br />Referrals</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Accepts Microsite Referrals',
                        field: 'isAcceptingPatientReferralsForMicrosites',
                        width: 95,
                        cellClass: 'center-list-referrals-cell action-menu',
                        headerClass: 'center-list-referrals-header',
                        cellRendererParams: {
                            productAlias: products.IsAcceptingPatientReferralsForMicrosites,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.isAcceptingPatientReferralsForMicrosites == -1 ? 0.5 : props.data.isAcceptingPatientReferralsForMicrosites,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },

                    {
                        colId: 'refMSC',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Patients<br />Desiring<br />Microsite</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Patients Desiring Microsite Referral Count',
                        field: 'patientsDesiringMicrositeReferralCount',
                        width: 95,
                        cellClass: 'center-list-referrals-cell',
                        headerClass: 'center-list-referrals-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.value > 0 ? props.value : ''
                        },
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },

                    {
                        colId: 'refK4L',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Accepting<br />KFL Patient<br />Referrals</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Patients Desiring KFL',
                        field: 'acceptingKflPatientReferrals',
                        width: 80,
                        cellClass: 'center-list-referrals-cell',
                        headerClass: 'center-list-referrals-header',
                        cellRendererParams: {
                            productAlias: products.AcceptingKfLPatientReferrals,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },

                    {
                        colId: 'refMSC',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Patients<br />Desiring<br />KFL</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Patients Desiring KFL Referral Count',
                        field: 'patientsDesiringKflReferralCount',
                        width: 85,
                        cellClass: 'center-list-referrals-cell',
                        headerClass: 'center-list-referrals-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.value > 0 ? props.value : ''
                        },
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },


                    {
                        colId: 'refMSC',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <HeaderWrapper>Total<br />Referred<br />Patients</HeaderWrapper>
                            </SortableHeaderComponent>,
                        headerName: 'Patients Total Count',
                        field: 'patientsTotalCount',
                        width: 95,
                        cellClass: 'center-list-referrals-cell',
                        headerClass: 'center-list-referrals-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.value > 0 ? props.value : ''
                        },
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                ]
            },

            {
                groupId: 'other',
                headerName: 'Other',
                headerClass: 'center-list-other-group-header',
                children: [
                    {
                        colId: 'otherCLS',
                        headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Included<br />in CLS</HeaderWrapper></SortableHeaderComponent>,
                        headerName: 'Include in CLS',
                        field: 'includedInCenterListingService',
                        width: 75,
                        cellClass: 'center-list-other-cell action-menu',
                        headerClass: 'center-list-other-header',
                        cellRendererParams: {
                            productAlias: products.IncludedInCenterListingService,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.includedInCenterListingService == -1 ? 0.5 : props.data.includedInCenterListingService,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'otherDSD',
                        headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>DSD<br />User</HeaderWrapper></SortableHeaderComponent>,
                        headerName: 'DSD User',
                        field: 'donorShieldDirectUser',
                        width: 70,
                        cellClass: 'center-list-other-cell action-menu',
                        headerClass: 'center-list-other-header',
                        cellRendererParams: {
                            productAlias: products.DonorShieldDirectUser,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.donorShieldDirectUser == -1 ? 0.5 : props.data.donorShieldDirectUser,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'otherDSDfU',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger='hover' placement='top' overlay={donorShieldDirectFullyUtilizedOverlay} rootClose>
                                    <HeaderWrapper>DSD<br />Fully Utilized</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'DSD Fully Utilized',
                        field: 'donorShieldDirectFullyUtilized',
                        width: 95,
                        cellClass: 'center-list-other-cell action-menu',
                        headerClass: 'center-list-other-header',
                        cellRendererParams: {
                            productAlias: products.DonorShieldDirectFullyUtilized,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.donorShieldDirectFullyUtilized == -1 ? 0.5 : props.data.donorShieldDirectFullyUtilized,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'otherDSDUt',
                        headerComponentFramework: (props: IHeaderParams) =>
                            <SortableHeaderComponent {...props}>
                                <OverlayTrigger trigger='hover' placement='top' overlay={donorShieldDirectUtilizationOverlay} rootClose>
                                    <HeaderWrapper>DSD<br />Utilization</HeaderWrapper>
                                </OverlayTrigger>
                            </SortableHeaderComponent>,
                        headerName: 'DSD Utilization',
                        field: 'dsdUtilization',
                        width: 80,
                        cellClass: 'center-list-other-cell',
                        headerClass: 'center-list-other-header',
                        cellRendererFramework: (props: ICellRendererParams) => {
                            if (props.data.isSummary || props.data.isProductOwner) {
                                return <SaturationSummaryRenderer {...props} />
                            }

                            return props.value > 0 ? parseFloat(props.value).toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%' : ''
                        },
                        valueGetter: (props: ValueGetterParams) => props.data.donorShieldDirectUser ? props.data.dsdUtilization : -1,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    },
                    {
                        colId: 'otherDSDL',
                        headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>
                            <HeaderWrapper>DSD<br />Liver<br />Participant</HeaderWrapper></SortableHeaderComponent>,
                        headerName: 'DSD Liver Participant',
                        field: 'donorShieldDirectLiverParticipant',
                        width: 70,
                        cellClass: 'center-list-other-cell action-menu',
                        headerClass: 'center-list-other-header',
                        cellRendererParams: {
                            productAlias: products.DonorShieldDirectLiver,
                            products: this.props.products,
                            productCenters: this.props.productCenters,
                            onItemClicked: this.props.onItemClicked,
                            onCloseProduct: this.props.onCloseProduct,
                            onDeleteProduct: this.props.onDeleteProduct
                        },
                        cellRendererFramework: SaturationRenderer,
                        valueGetter: (props: ValueGetterParams) => props.data.donorShieldDirectLiverParticipant == -1 ? 0.5 : props.data.donorShieldDirectLiverParticipant,
                        sortingOrder: ['desc', 'asc'],
                        sortable: true,
                        hide: false
                    }
                ]
            }
        ];

        this.setState({
            columns
        });
    }

    getSaturationSummary = (list: ICenterSaturation[]): [ISaturationSummary, ISaturationSummaryProductOwner] => {
        let productCount = Object.keys(this.props.productOwners).length;

        let ownerResults: ISaturationSummaryProductOwner = {
            isProductOwner: true,
            isMemberCenter: this.props.productOwners[products.MemberCenter],
            isRemoteDonationCenter: this.props.productOwners[products.RemoteDonationCenter],
            allInAddendumSigned: this.props.productOwners[products.AllInAddendumSigned],
            allInBestGuess: this.props.productOwners[products.AllInAddendumSigned],
            partnerCenter: this.props.productOwners[products.PartnerCenter],
            screeningVirtualCrossMatchUser: this.props.productOwners[products.Vxm],
            donorProtectionAddendumSigned: this.props.productOwners[products.DonorProtectionAddendumSigned],
            vem: this.props.productOwners[products.VoucherEducationModule],

            voucherProgramActive: this.props.productOwners[products.VoucherProgramActive],
            voucherProgramUtilization: this.props.productOwners[products.VoucherProgramActive],

            donorShieldDirectUser: this.props.productOwners[products.DonorShieldDirectUser],
            donorShieldDirectFullyUtilized: this.props.productOwners[products.DonorShieldDirectFullyUtilized],
            donorShieldDirectLiverParticipant: this.props.productOwners[products.DonorShieldDirectLiver],
            dsdUtilization: this.props.productOwners[products.DonorShieldDirectUser],

            dashActive: this.props.productOwners[products.DashActive],
            dashFullyUtilized: this.props.productOwners[products.DashFullyUtilized],
            dashUtilization: this.props.productOwners[products.DashActive],

            liverDashActive: this.props.productOwners[products.LiverDashActive],

            pwlActive: this.props.productOwners[products.PwlActive],
            pwlFullyUtilized: this.props.productOwners[products.PwlFullyUtilized],
            pwlUtilization: this.props.productOwners[products.PwlActive],

            automatedDonorFollowUpActive: this.props.productOwners[products.AutomatedDonorFollowUpActive],
            automatedDonorFollowUpFullyUtilized: this.props.productOwners[products.AutomatedDonorFollowUpFullyUtilized],
            automatedDonorFollowUpUtilization: this.props.productOwners[products.AutomatedDonorFollowUpActive],

            micrositesActive: this.props.productOwners[products.MicrositesActive],
            micrositesFullyUtilized: this.props.productOwners[products.MicrositesFullyUtilized],
            micrositeUtilization: this.props.productOwners[products.MicrositesActive],
            micrositeCount: this.props.productOwners[products.MicrositesActive],
            micrositeActiveStarterSiteCount: this.props.productOwners[products.MicrositesActive],
            micrositeActiveCustomSiteCount: this.props.productOwners[products.MicrositesActive],
            micrositesLdtxpL12: this.props.productOwners[products.MicrositesActive],

            completedMoreThan0PatientTrainingSessions: this.props.productOwners[products.CompletedMoreThan0PatientTrainingSessions],
            completedMoreThan2PatientTrainingSessions: this.props.productOwners[products.CompletedMoreThan2PatientTrainingSessions],

            isAcceptingPatientReferralsForMicrosites: this.props.productOwners[products.IsAcceptingPatientReferralsForMicrosites],
            acceptingDonorReferrals: this.props.productOwners[products.AcceptingDonorReferrals],
            acceptingPatientReferrals: this.props.productOwners[products.AcceptingPatientReferrals],
            acceptingKfLPatientReferrals: this.props.productOwners[products.AcceptingKfLPatientReferrals],

            optInAutomatedSerologies: this.props.productOwners[products.OptInAutomatedSerologies],
            includedInCenterListingService: this.props.productOwners[products.IncludedInCenterListingService],

            donorReferralCount: this.props.productOwners[products.AcceptingDonorReferrals],
            patientsWithLivingDonorReferralCount: this.props.productOwners[products.AcceptingPatientReferrals],
            patientsDesiringMicrositeReferralCount: this.props.productOwners[products.IsAcceptingPatientReferralsForMicrosites],
            patientsDesiringKflReferralCount: this.props.productOwners[products.AcceptingKfLPatientReferrals],
            patientsTotalCount: this.props.productOwners[products.AcceptingPatientReferrals],

            automatedCollectionsAndClearing: this.props.productOwners[products.AutomatedCollectionsAndClearing],
            automatedCollectionsAndClearingInvoiceCount: this.props.productOwners[products.AutomatedCollectionsAndClearing],
            shbEligibleSwaps: this.props.productOwners[products.StreamlinedBillingService],
            shbUtilized: this.props.productOwners[products.StreamlinedBillingService],
            shbFullyUtilized: this.props.productOwners[products.StreamlinedBillingService],
            isExpertSystem: this.props.productOwners[products.ExpertSystem],
            expertSystemFullyUtilized: this.props.productOwners[products.ExpertSystem],

            ubpInvTrigCount: this.props.productOwners[products.StreamlinedBillingService],

            streamlinedBillingService: this.props.productOwners[products.StreamlinedBillingService],
            billable: this.props.productOwners[products.Billable],
            donorCareNetworkCenter: this.props.productOwners[products.DonorCareNetworkCenter],
            offerDonorConnect: this.props.productOwners[products.OfferDonorConnect],
            goldStarCenter: this.props.productOwners['goldStarCenter'],
            xpLast12Months: this.props.productOwners['xpLast12Months'],

            kidneyForLifeActive: this.props.productOwners[products.KidneyForLifeActive],
            kidneyForLifeFullyUtilized: this.props.productOwners[products.KidneyForLifeFullyUtilized],
            kidneyForLifeUtilization: this.props.productOwners[products.KidneyForLifeActive],
            kidneyForLifeSuccess: this.props.productOwners[products.KidneyForLifeActive],
            lowExpletTxpCountL12M: this.props.productOwners[products.KidneyForLifeActive],

            directStreamlinedSerologyCount: this.props.productOwners[products.DirectStreamlinedSerologyCount],
            homeBloodDrawCount: this.props.productOwners[products.HomeBloodDrawCountTarget],

            saturationTotal: { productId: 0, initials: 'AC', name: 'Andre Carvalho', isActive: true },
            saturationAnnualGoal: { productId: 0, initials: 'AC', name: 'Andre Carvalho', isActive: true },
            saturationVariance: { productId: 0, initials: 'AC', name: 'Andre Carvalho', isActive: true }
        };

        let results: ISaturationSummary = {
            isSummary: true,
            isMemberCenter: { total: 0, percent: 0 },
            isRemoteDonationCenter: { total: 0, percent: 0 },
            allInAddendumSigned: { total: 0, percent: 0 },
            allInBestGuess: { total: 0, percent: 0 },
            partnerCenter: { total: 0, percent: 0 },
            screeningVirtualCrossMatchUser: { total: 0, percent: 0 },
            donorProtectionAddendumSigned: { total: 0, percent: 0 },
            vem: { total: 0, percent: 0 },

            voucherProgramActive: { total: 0, percent: 0 },
            voucherProgramUtilization: { total: 0, percent: 0 },

            donorShieldDirectUser: { total: 0, percent: 0 },
            donorShieldDirectFullyUtilized: { total: 0, percent: 0 },
            dsdUtilization: { total: 0, percent: 0 },
            donorShieldDirectLiverParticipant: { total: 0, percent: 0 },

            dashActive: { total: 0, percent: 0 },
            dashFullyUtilized: { total: 0, percent: 0 },
            dashUtilization: { total: 0, percent: 0 },

            liverDashActive: { total: 0, percent: 0 },

            pwlActive: { total: 0, percent: 0 },
            pwlFullyUtilized: { total: 0, percent: 0 },
            pwlUtilization: { total: 0, percent: 0 },

            automatedDonorFollowUpActive: { total: 0, percent: 0 },
            automatedDonorFollowUpFullyUtilized: { total: 0, percent: 0 },
            automatedDonorFollowUpUtilization: { total: 0, percent: 0 },

            micrositesActive: { total: 0, percent: 0 },
            micrositesFullyUtilized: { total: 0, percent: 0 },
            micrositeUtilization: { total: 0, percent: 0 },
            micrositeCount: { total: 0, percent: 0 },
            micrositeActiveStarterSiteCount: { total: 0, percent: 0 },
            micrositeActiveCustomSiteCount: { total: 0, percent: 0 },
            micrositesLdtxpL12: { total: 0, percent: 0 },

            completedMoreThan0PatientTrainingSessions: { total: 0, percent: 0 },
            completedMoreThan2PatientTrainingSessions: { total: 0, percent: 0 },
            isAcceptingPatientReferralsForMicrosites: { total: 0, percent: 0 },
            acceptingDonorReferrals: { total: 0, percent: 0 },
            acceptingPatientReferrals: { total: 0, percent: 0 },
            optInAutomatedSerologies: { total: 0, percent: 0 },
            includedInCenterListingService: { total: 0, percent: 0 },

            donorReferralCount: { total: 0, percent: 0 },
            patientsWithLivingDonorReferralCount: { total: 0, percent: 0 },
            patientsDesiringMicrositeReferralCount: { total: 0, percent: 0 },
            acceptingKflPatientReferrals: { total: 0, percent: 0 },
            patientsDesiringKflReferralCount: { total: 0, percent: 0 },
            patientsTotalCount: { total: 0, percent: 0 },

            automatedCollectionsAndClearing: { total: 0, percent: 0 },
            automatedCollectionsAndClearingInvoiceCount: { total: 0, percent: 0 },
            shbEligibleSwaps: { total: 0, percent: 0 },
            shbUtilized: { total: 0, percent: 0 },
            shbFullyUtilized: { total: 0, percent: 0 },
            isExpertSystem: { total: 0, percent: 0 },
            expertSystemFullyUtilized: { total: 0, percent: 0 },
            ubpInvTrigCount: { total: 0, percent: 0 },
            streamlinedBillingService: { total: 0, percent: 0 },
            billable: { total: 0, percent: 0 },
            donorCareNetworkCenter: { total: 0, percent: 0 },
            offerDonorConnect: { total: 0, percent: 0 },
            goldStarCenter: { total: 0, percent: 0 },
            xpLast12Months: { total: 0, percent: 0 },

            kidneyForLifeActive: { total: 0, percent: 0 },
            kidneyForLifeFullyUtilized: { total: 0, percent: 0 },
            kidneyForLifeUtilization: { total: 0, percent: 0 },
            kidneyForLifeSuccess: { total: 0, percent: 0 },
            lowExpletTxpCountL12M: { total: 0, percent: 0 },

            directStreamlinedSerologyCount: { total: 0, percent: 0 },
            homeBloodDrawCount: { total: 0, percent: 0 },

            saturationTotal: { total: 0, percent: 0 },
            saturationAnnualGoal: { total: 0, percent: 0 },
            saturationVariance: { total: 0, percent: 0 }
        };

        let totalStandardVouchers = 0;
        let totalFamilyVouchers = 0;
        let totalVouchers = 0;
        let totalDonors = 0;
        let nddCount = 0;
        let dashCount = 0;
        let livingDonorCount = 0;
        let followupCount = 0;
        let livingDonorCountQuarterly = 0;
        let lowEpletTxpCount = 0;
        let lowExpletTxpCountL12M = 0;
        let txpCountAllTime = 0;
        let micrositesLdtxpL12 = 0;

        let exportableRecipient3GTypingCount = 0;
        let txpRecipient3GTypingCount = 0;
        let txpCountNonAdpChipL6M = 0;
        let exportableRecipientCount = 0;

        let micrositeCount = 0;
        let micrositeActiveStarterSiteCount = 0;
        let micrositeActiveCustomSiteCount = 0;
        let waitListCount = 0;

        list.forEach(center => {
            results.xpLast12Months.total += center.xpLast12Months;

            if (center.isMemberCenter == 1 || center.isMemberCenter == 3)
                results.isMemberCenter.total++;

            if (center.isRemoteDonationCenter == 1 || center.isRemoteDonationCenter == 3)
                results.isRemoteDonationCenter.total++;

            if (center.allInAddendumSigned == 1 || center.allInAddendumSigned == 3)
                results.allInAddendumSigned.total++;

            if (center.allInBestGuess)
                results.allInBestGuess.total++;

            if (center.vem == 1 || center.vem == 3)
                results.vem.total++;

            if (center.partnerCenter == 1 || center.partnerCenter == 3)
                results.partnerCenter.total++;

            if (center.screeningVirtualCrossMatchUser == 1 || center.screeningVirtualCrossMatchUser == 3)
                results.screeningVirtualCrossMatchUser.total++;

            if (center.donorProtectionAddendumSigned == 1 || center.donorProtectionAddendumSigned == 3)
                results.donorProtectionAddendumSigned.total++;

            if (center.voucherProgramActive == 1 || center.voucherProgramActive == 3) {
                results.voucherProgramActive.total++;
                results.voucherProgramUtilization.total += center.voucherProgramUtilization;
            }

            totalStandardVouchers += (center.voucherProgramActive ? center.totalStandardVouchers : 0);
            totalFamilyVouchers += center.totalFamilyVouchers;
            totalVouchers += (center.voucherProgramActive ? center.totalVouchers : 0);
            totalDonors += center.totalDonors;
            nddCount += center.nddCount;
            dashCount += center.dashCount;
            livingDonorCount += center.livingDonorCount;
            followupCount += center.followupCount;
            livingDonorCountQuarterly += center.livingDonorCountQuarterly;

            lowEpletTxpCount += (center.kidneyForLifeActive == 1 || center.kidneyForLifeActive == 3) ? center.lowExpletTxpCountL12M : 0;
            lowExpletTxpCountL12M += center.lowExpletTxpCountL12M;

            txpCountAllTime += (center.kidneyForLifeActive == 1 || center.kidneyForLifeActive == 3) ? center.txpCountAllTime : 0;

            exportableRecipient3GTypingCount += (center.kidneyForLifeActive == 1 || center.kidneyForLifeActive == 3) ? center.exportableRecipient3GTypingCount : 0;
            txpRecipient3GTypingCount += (center.kidneyForLifeActive == 1 || center.kidneyForLifeActive == 3) ? center.txpRecipient3GTypingCount : 0;
            txpCountNonAdpChipL6M += (center.kidneyForLifeActive == 1 || center.kidneyForLifeActive == 3) ? center.txpCountNonAdpChipL6M : 0;
            exportableRecipientCount += (center.kidneyForLifeActive == 1 || center.kidneyForLifeActive == 3) ? center.exportableRecipientCount : 0;

            micrositeCount += center.micrositeCount;
            micrositeActiveStarterSiteCount += center.micrositeActiveStarterSiteCount;
            micrositeActiveCustomSiteCount += center.micrositeActiveCustomSiteCount;
            micrositesLdtxpL12 += center.micrositesLdtxpL12;

            waitListCount += center.waitListCount;

            if (center.donorShieldDirectUser == 1 || center.donorShieldDirectUser == 3) {
                results.donorShieldDirectUser.total++;
                results.dsdUtilization.total += center.dsdUtilization;
            }

            if (center.donorShieldDirectFullyUtilized == 1 || center.donorShieldDirectFullyUtilized == 3)
                results.donorShieldDirectFullyUtilized.total++;

            if (center.dashActive == 1 || center.dashActive == 3) {
                results.dashActive.total++;
            }

            if (center.dashFullyUtilized == 1 || center.dashFullyUtilized == 3)
                results.dashFullyUtilized.total++;

            if (center.liverDashActive == 1 || center.liverDashActive == 3)
                results.liverDashActive.total++;

            if (center.donorShieldDirectLiverParticipant == 1 || center.donorShieldDirectLiverParticipant == 3)
                results.donorShieldDirectLiverParticipant.total++;

            if (center.pwlActive == 1 || center.pwlActive == 3) {
                results.pwlActive.total++;
                results.pwlUtilization.total += center.pwlUtilization;
            }

            if (center.pwlFullyUtilized == 1 || center.pwlFullyUtilized == 3)
                results.pwlFullyUtilized.total++;

            if (center.automatedDonorFollowUpActive == 1 || center.automatedDonorFollowUpActive == 3)
                results.automatedDonorFollowUpActive.total++;

            if (center.automatedDonorFollowUpFullyUtilized == 1 || center.automatedDonorFollowUpFullyUtilized == 3)
                results.automatedDonorFollowUpFullyUtilized.total++;

            if (center.micrositesActive == 1 || center.micrositesActive == 3)
                results.micrositesActive.total++;

            if (center.micrositesFullyUtilized == 1 || center.micrositesFullyUtilized == 3)
                results.micrositesFullyUtilized.total++;

            results.micrositeCount.total += center.micrositeCount;
            results.micrositeActiveStarterSiteCount.total += center.micrositeActiveStarterSiteCount;
            results.micrositeActiveCustomSiteCount.total += center.micrositeActiveCustomSiteCount;
            results.micrositesLdtxpL12.total += center.micrositesLdtxpL12;

            if (center.isAcceptingPatientReferralsForMicrosites == 1 || center.isAcceptingPatientReferralsForMicrosites == 3)
                results.isAcceptingPatientReferralsForMicrosites.total++;

            if (center.completedMoreThan0PatientTrainingSessions == 1 || center.completedMoreThan0PatientTrainingSessions == 3)
                results.completedMoreThan0PatientTrainingSessions.total++;

            if (center.completedMoreThan2PatientTrainingSessions == 1 || center.completedMoreThan2PatientTrainingSessions == 3)
                results.completedMoreThan2PatientTrainingSessions.total++;

            if (center.acceptingDonorReferrals == 1 || center.acceptingDonorReferrals == 3)
                results.acceptingDonorReferrals.total++;

            if (center.acceptingPatientReferrals == 1 || center.acceptingPatientReferrals == 3)
                results.acceptingPatientReferrals.total++;

            if (center.optInAutomatedSerologies == 1 || center.optInAutomatedSerologies == 3)
                results.optInAutomatedSerologies.total++;

            if (center.includedInCenterListingService == 1 || center.includedInCenterListingService == 3)
                results.includedInCenterListingService.total++;

            if (center.automatedCollectionsAndClearing == 1 || center.automatedCollectionsAndClearing == 3)
                results.automatedCollectionsAndClearing.total++;

            results.automatedCollectionsAndClearingInvoiceCount.total += center.automatedCollectionsAndClearingInvoiceCount;
            results.shbEligibleSwaps.total += center.shbEligibleSwaps;
            results.shbUtilized.total += center.shbUtilized;
            results.shbFullyUtilized.total += center.shbFullyUtilized;

            if (center.isExpertSystem == 1 || center.isExpertSystem == 3)
                results.isExpertSystem.total++;

            results.expertSystemFullyUtilized.total += center.expertSystemFullyUtilized;
            results.ubpInvTrigCount.total += center.ubpInvTrigCount;

            if (center.streamlinedBillingService == 1 || center.streamlinedBillingService == 3)
                results.streamlinedBillingService.total++;

            if (center.billable)
                results.billable.total++;

            if (center.donorCareNetworkCenter == 1 || center.donorCareNetworkCenter == 3)
                results.donorCareNetworkCenter.total++;

            if (center.offerDonorConnect == 1 || center.offerDonorConnect == 3)
                results.offerDonorConnect.total++;

            if (center.kidneyForLifeActive == 1 || center.kidneyForLifeActive == 3)
                results.kidneyForLifeActive.total++;

            if (center.kidneyForLifeFullyUtilized == 1 || center.kidneyForLifeFullyUtilized == 3)
                results.kidneyForLifeFullyUtilized.total++

            results.kidneyForLifeUtilization.total += center.kidneyForLifeUtilization;
            results.homeBloodDrawCount.total += center.homeBloodDrawCount;
            results.directStreamlinedSerologyCount.total += center.directStreamlinedSerologyCount;

            results.saturationTotal.total += center.saturationTotal;
            results.saturationAnnualGoal.total += center.saturationAnnualGoal;

            results.donorReferralCount.total += center.donorReferralCount;
            results.patientsWithLivingDonorReferralCount.total += center.patientsWithLivingDonorReferralCount;
            results.patientsDesiringMicrositeReferralCount.total += center.patientsDesiringMicrositeReferralCount;

            if (center.kidneyForLifeFullyUtilized == 1 || center.kidneyForLifeFullyUtilized == 3)
                results.kidneyForLifeFullyUtilized.total++;

            if (center.acceptingKflPatientReferrals == 1 || center.acceptingKflPatientReferrals == 3)
                results.acceptingKflPatientReferrals.total++;

            results.patientsDesiringKflReferralCount.total += center.patientsDesiringKflReferralCount;
            results.patientsTotalCount.total += center.patientsTotalCount;
        });

        results.shbEligibleSwaps.percent = list.length > 0 ? results.shbEligibleSwaps.total / list.length : 0;
        results.shbUtilized.percent = list.length > 0 ? results.shbUtilized.total / list.length : 0;
        results.shbFullyUtilized.percent = list.length > 0 ? results.shbFullyUtilized.total / list.length : 0;
        results.isExpertSystem.percent = list.length > 0 ? results.isExpertSystem.total / list.length : 0;
        results.expertSystemFullyUtilized.percent = list.length > 0 ? results.expertSystemFullyUtilized.total / list.length : 0;
        results.ubpInvTrigCount.percent = list.length > 0 ? results.ubpInvTrigCount.total / list.length : 0;

        results.isMemberCenter.percent = list.length > 0 ? results.isMemberCenter.total / list.length : 0;
        results.isRemoteDonationCenter.percent = list.length > 0 ? results.isRemoteDonationCenter.total / list.length : 0;
        results.allInAddendumSigned.percent = list.length > 0 ? results.allInAddendumSigned.total / list.length : 0;
        results.allInBestGuess.percent = list.length > 0 ? results.allInBestGuess.total / list.length : 0;
        results.partnerCenter.percent = list.length > 0 ? results.partnerCenter.total / list.length : 0;
        results.screeningVirtualCrossMatchUser.percent = list.length > 0 ? results.screeningVirtualCrossMatchUser.total / list.length : 0;
        results.donorProtectionAddendumSigned.percent = list.length > 0 ? results.donorProtectionAddendumSigned.total / list.length : 0;
        results.vem.percent = list.length > 0 ? results.vem.total / list.length : 0;

        results.voucherProgramActive.percent = list.length > 0 ? results.voucherProgramActive.total / list.length : 0;

        results.voucherProgramUtilization.percent = (totalDonors / totalVouchers) * 100.0;

        results.donorShieldDirectUser.percent = list.length > 0 ? results.donorShieldDirectUser.total / list.length : 0;
        results.donorShieldDirectFullyUtilized.percent = list.length > 0 ? results.donorShieldDirectFullyUtilized.total / list.length : 0;
        results.dsdUtilization.percent = results.donorShieldDirectUser.total > 0 ? results.dsdUtilization.total / results.donorShieldDirectUser.total : 0;
        results.donorShieldDirectLiverParticipant.percent = list.length > 0 ? results.donorShieldDirectLiverParticipant.total / list.length : 0;

        results.dashActive.percent = list.length > 0 ? results.dashActive.total / list.length : 0;
        results.dashFullyUtilized.percent = list.length > 0 ? results.dashFullyUtilized.total / list.length : 0;
        results.dashUtilization.percent = livingDonorCount > 0 ? (dashCount / livingDonorCount) * 100.0 : 0;

        results.liverDashActive.percent = list.length > 0 ? results.liverDashActive.total / list.length : 0;

        results.pwlActive.percent = list.length > 0 ? results.pwlActive.total / list.length : 0;
        results.pwlFullyUtilized.percent = list.length > 0 ? results.pwlFullyUtilized.total / list.length : 0;
        results.pwlUtilization.percent = results.pwlActive.total > 0 ? results.pwlUtilization.total / results.pwlActive.total : 0;

        results.automatedDonorFollowUpActive.percent = list.length > 0 ? results.automatedDonorFollowUpActive.total / list.length : 0;
        results.automatedDonorFollowUpFullyUtilized.percent = list.length > 0 ? results.automatedDonorFollowUpFullyUtilized.total / list.length : 0;
        results.automatedDonorFollowUpUtilization.percent = livingDonorCountQuarterly > 0 ? (followupCount / livingDonorCountQuarterly) : 0;

        results.micrositesActive.percent = list.length > 0 ? results.micrositesActive.total / list.length : 0;
        results.micrositesFullyUtilized.percent = list.length > 0 ? results.micrositesFullyUtilized.total / list.length : 0;
        results.micrositeCount.average = list.length > 0 ? results.micrositeCount.total / list.length : 0;
        results.micrositeActiveStarterSiteCount.average = list.length > 0 ? results.micrositeActiveStarterSiteCount.total / list.length : 0;
        results.micrositeActiveCustomSiteCount.average = list.length > 0 ? results.micrositeActiveCustomSiteCount.total / list.length : 0;
        results.micrositesLdtxpL12.average = list.length > 0 ? results.micrositesLdtxpL12.total / list.length : 0;
        results.micrositeUtilization.percent = micrositeCount / waitListCount;

        results.isAcceptingPatientReferralsForMicrosites.percent = list.length > 0 ? results.isAcceptingPatientReferralsForMicrosites.total / list.length : 0;
        results.completedMoreThan0PatientTrainingSessions.percent = list.length > 0 ? results.completedMoreThan0PatientTrainingSessions.total / list.length : 0;
        results.completedMoreThan2PatientTrainingSessions.percent = list.length > 0 ? results.completedMoreThan2PatientTrainingSessions.total / list.length : 0;
        results.acceptingDonorReferrals.percent = list.length > 0 ? results.acceptingDonorReferrals.total / list.length : 0;
        results.acceptingPatientReferrals.percent = list.length > 0 ? results.acceptingPatientReferrals.total / list.length : 0;

        results.acceptingKflPatientReferrals.percent = list.length > 0 ? (results.acceptingKflPatientReferrals.total / list.length) * 100 : 0;
        results.optInAutomatedSerologies.percent = list.length > 0 ? results.optInAutomatedSerologies.total / list.length : 0;
        results.includedInCenterListingService.percent = list.length > 0 ? results.includedInCenterListingService.total / list.length : 0;

        results.automatedCollectionsAndClearing.percent = list.length > 0 ? results.automatedCollectionsAndClearing.total / list.length : 0;
        results.streamlinedBillingService.percent = list.length > 0 ? results.streamlinedBillingService.total / list.length : 0;

        results.billable.percent = list.length > 0 ? results.billable.total / list.length : 0;

        results.donorCareNetworkCenter.percent = list.length > 0 ? results.donorCareNetworkCenter.total / list.length : 0;
        results.offerDonorConnect.percent = list.length > 0 ? results.offerDonorConnect.total / list.length : 0;
        results.goldStarCenter.percent = list.length > 0 ? results.goldStarCenter.total / list.length : 0;

        results.kidneyForLifeActive.percent = list.length > 0 ? results.kidneyForLifeActive.total / list.length : 0;
        results.kidneyForLifeFullyUtilized.percent = results.kidneyForLifeActive.total > 0 ? results.kidneyForLifeFullyUtilized.total / results.kidneyForLifeActive.total : 0;
        results.kidneyForLifeUtilization.percent = results.kidneyForLifeUtilization.total / results.kidneyForLifeActive.total;
        results.kidneyForLifeSuccess.percent = (lowEpletTxpCount / txpRecipient3GTypingCount) * 100;
        results.lowExpletTxpCountL12M.total = lowExpletTxpCountL12M;

        results.saturationTotal.percent = (results.saturationTotal.total / (productCount * list.length) * 100);
        results.saturationAnnualGoal.percent = results.saturationAnnualGoal.total > 0 ? (results.saturationTotal.total / results.saturationAnnualGoal.total) * 100 : 0;
        results.saturationVariance.total = results.saturationAnnualGoal.total - results.saturationTotal.total;
        results.saturationVariance.percent = results.saturationAnnualGoal.total > 0 ? results.saturationTotal.total / results.saturationAnnualGoal.total : 0;

        results.donorReferralCount.average = list.length > 0 ? results.donorReferralCount.total / list.length : 0;
        results.patientsWithLivingDonorReferralCount.average = list.length > 0 ? results.patientsWithLivingDonorReferralCount.total / list.length : 0;
        results.patientsDesiringMicrositeReferralCount.average = list.length > 0 ? results.patientsDesiringMicrositeReferralCount.total / list.length : 0;
        results.patientsDesiringKflReferralCount.average = list.length > 0 ? results.patientsDesiringKflReferralCount.total / list.length : 0;
        results.patientsTotalCount.average = list.length > 0 ? results.patientsTotalCount.total / list.length : 0;

        return [results, ownerResults];
    }

    handleDeselectAllRows = () => {
        this.props.onDeselectAllRows();
    }

    handleShowOnlySelectedRows = () => {
        this.props.onShowOnlySelectedRows();
    }

    handleSaveAnnualGoal = (centerId: number, goal: number) => {
        this.props.onSaveSaturationAnnualGoal(centerId, goal);
    }

    handleCancelAnnualGoal = () => {
        this.props.gridApi.stopEditing(true);
    }

    handleShowCategoryValues = () => {
        this.setState({
            showCategoryValues: !this.state.showCategoryValues
        }, () => {
            this.props.gridApi.refreshCells({ force: true });
        });
    }

    handleShowNoteValues = () => {
        this.setState({
            showNoteValues: !this.state.showNoteValues
        }, () => {
            this.props.gridApi.refreshCells({ force: true });

            if (this.state.showNoteValues) {
                this.props.gridColumnApi.autoSizeColumn('notes');
            } else {
                this.props.gridColumnApi.setColumnWidth('notes', 65);
            }
        });
    }

    handleProductOwnerClicked = (productId: number) => {
        this.props.onProductOwnerClicked(productId).then(() => {
            let summary = this.getSaturationSummary(this.props.data);
            this.props.gridApi.setPinnedTopRowData(summary);
            this.props.gridApi.refreshCells({ force: true });
        });
    }

    categoryValueGetter = (props: ValueGetterParams) => {
        let sm = props.api.getSortModel();

        if (sm.length > 0 && sm[0].colId == 'category' && sm[0].sort == 'asc' && props.data.category == '')
            return 'Z';

        if (sm.length > 0 && sm[0].colId == 'category' && sm[0].sort == 'desc' && props.data.category == '')
            return '1';

        return props.data.category;
    }

    render = () => {
        const summary = this.getSaturationSummary(this.props.data);
        const productKeys = Object.keys(this.props.productOwners);

        if (productKeys.length == 0)
            return null;

        return (
            <>
                <GridWrapper className='container-fluid ag-theme-bootstrap'>
                    <AgGridReact
                        columnDefs={this.state.columns}
                        rowData={this.props.data}
                        headerHeight={60}
                        groupHeaderHeight={30}
                        rowHeight={30}
                        pinnedTopRowData={summary}
                        onGridReady={this.props.onGridReady}
                        noRowsOverlayComponentFramework={() => <div>No centers found...</div>}
                        rowSelection='multiple'
                        rowMultiSelectWithClick={true}
                        suppressRowClickSelection={true}
                        suppressCellSelection={true}
                        suppressContextMenu={true}
                        rowBuffer={100}
                        stopEditingWhenGridLosesFocus={true}
                        onSortChanged={(e: SortChangedEvent) => {
                            e.api.refreshCells();
                        }}
                        onCellFocused={(e: CellFocusedEvent) => {
                            let colId = e.column.getColId();

                            if (e.column && allowedRowSelectionColumns.indexOf(colId) < 0) {
                                (e.api as any).gridOptionsWrapper.gridOptions.suppressRowClickSelection = true;
                            }
                            else {
                                (e.api as any).gridOptionsWrapper.gridOptions.suppressRowClickSelection = false;
                            }
                        }}
                        onCellKeyDown={(e: CellKeyDownEvent) => {
                        }}
                        onCellEditingStarted={(e: CellEditingStartedEvent) => {
                            this.currentValue = parseInt(e.value);
                        }}
                        onCellEditingStopped={(e: CellEditingStoppedEvent) => {
                            let valid = Utility.isNumber(e.value);

                            if (!valid) {
                                e.api.setFocusedCell(e.rowIndex, e.column.getColId());
                                e.api.startEditingCell({ rowIndex: e.rowIndex, colKey: e.column.getColId() });
                            } else {
                                if (parseInt(e.value) != this.currentValue) {
                                    this.props.onSaveSaturationAnnualGoal(e.data.id, parseInt(e.value));
                                    this.currentValue = null;
                                }
                            }
                        }}
                        onRowClicked={(e: RowClickedEvent) => {
                            let centerId = (e.data as ICenterSaturation).id;
                            this.props.onRowClicked(centerId);
                        }}
                        onBodyScroll={(e: any) => {
                            // console.log(e);
                        }}
                    />
                </GridWrapper>
            </>
        );
    }
}

export default SaturationGrid;